const qcNoteES = {
    "view": {
        "message": {
            "releaseHasQCIssues": "El lanzamiento {{releaseName}} tiene problemas de QC, por favor edita el lanzamiento para obtener comentarios detallados de QC, realiza los cambios necesarios y vuelve a enviar.",
            "trackHasQCIssues": "La pista {{trackName}} tiene problemas de QC, por favor edita la pista para obtener comentarios detallados de QC, realiza los cambios necesarios y vuelve a enviar."
        }
    }
};

export default qcNoteES;